module.exports = __webpack_public_path__ + "static/img/newsff.f01fbc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsff.png
// module id = E/08
// module chunks = 45